import React from 'react'
import CustomInput from '../../components/atoms/Inputs/CustomInput'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'

export const AskingPrice = ({ formik, nextStep, prevStep }) => {
    const { t } = useTranslation()

    return (
        <>
            <h2 className="text-left light-white mb-3">{t('asking_price')}</h2>
            <div className="cutomRadioButtons">
                <form>
                    <p className="label">
                        {t('the_price_you_can_ask_for_your_car')} <span>*</span>
                    </p>
                    <CustomInput
                        label=""
                        type="number"
                        inputClassName="input-login login-user-name"
                        labelClass="login-user-name-label light-white"
                        // placeholder="ABC12D"
                        endAdornment="SEK"
                        onChange={formik.handleChange}
                        name="price"
                        value={formik.values.price}
                        onBlur={formik.handleBlur}
                        helperText={
                            formik.touched.price && formik.errors.price ? formik.errors.price : null
                        }
                        error={formik.touched.price && formik.errors.price}
                    />
                    <PrimaryButton
                        customClassName="login-confirm-btn"
                        label={t('preview_info')}
                        iconRight={<span className="material-icons">arrow_right_alt</span>}
                        type="button"
                        onClick={nextStep}
                    />
                </form>
            </div>
        </>
    )
}
